import React from 'react';
import type { PopperProps } from '@mui/material/Popper';
import MuiPopper from '@mui/material/Popper';
import { styled } from 'styled-components';

const Molecule: React.FC<PopperProps> = (props) => <MuiPopper {...props} />;

export const Popper = styled(Molecule)({});
